import { queryOptions, useQuery } from '@tanstack/react-query';

import { POLLING_DELAY_MS } from '@cast/constants';
import { ApiResponse } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const ORGANIZATION_OVERVIEW_QUERY_KEY = 'organization-overview';

const apiFn = apiClient.costReport.getOrganizationOverview;

export type OrganizationOverviewQueryData = ApiResponse<typeof apiFn>;

export const getOrganizationOverviewQueryKey = (
  startTime: string,
  endTime: string
) => [ORGANIZATION_OVERVIEW_QUERY_KEY, startTime, endTime] as const;

export type UseOrganizationOverviewQueryArgs = {
  startTime: string;
  endTime: string;
  enabled?: boolean;
};

export const isOverviewQueryUnresolved = (
  data: unknown,
  error: unknown
): boolean => data == null && !error;

export const getOrganizationOverviewQueryOptions = ({
  startTime,
  endTime,
  enabled = true,
}: UseOrganizationOverviewQueryArgs) =>
  queryOptions({
    queryKey: getOrganizationOverviewQueryKey(startTime, endTime),
    queryFn: async () => {
      const { data } = await apiFn({
        startTime,
        endTime,
      });
      return data;
    },
    refetchInterval: POLLING_DELAY_MS,
    enabled,
  });

export const useOrganizationOverviewQuery = (
  args: UseOrganizationOverviewQueryArgs
) => {
  const { data, ...rest } = useQuery(getOrganizationOverviewQueryOptions(args));

  return { data, ...rest };
};
